import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../../data-storage.service';

@Component({
  selector: 'app-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.scss']
})
export class DeviceListComponent implements OnInit {

  constructor(public dataStorageService: DataStorageService) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/content/management/device-list/device-list.component.ts